export default __webpack_public_path__ + "static/testimonialHolder4-b4a91950542f559cfbbb3f818f7181a7.png";